export const SESSION_INVALID_KEY = "SESSION_INVALID"
const SESSION_STORAGE_EVENT = "session-storage"
const REDIRECT_URL_KEY = "REDIRECT_URL"
const IS_LOGGING_OUT_LOCK_KEY = "IS_LOGGING_OUT_LOCK"

export const SessionStorageService = {
    setRequireReAuthentication: () => sessionStorage.setItem("REQUIRE_RE_AUTHENTICATION", "true"),
    getRequireReAuthentication: () => !!sessionStorage.getItem("REQUIRE_RE_AUTHENTICATION"),

    // a lock to differentiate between 1) user is currently logging out and 2) unauthorized user paste a url
    // if 1) in login page, skip setRedirectUrl
    // if 2) after redirecting to login page, setRedirectUrl so user can be redirected to the original page
    setIsLoggingOut: () => sessionStorage.setItem(IS_LOGGING_OUT_LOCK_KEY, "true"),
    getIsLoggingOut: () => !!sessionStorage.getItem(IS_LOGGING_OUT_LOCK_KEY),
    clearIsLoggingOut: () => sessionStorage.removeItem(IS_LOGGING_OUT_LOCK_KEY),

    getSessionInvalid: () => sessionStorage.getItem(SESSION_INVALID_KEY),

    setSessionInvalid: () => {
        if (SessionStorageService.getSessionInvalid() === null) {
            sessionStorage.setItem(SESSION_INVALID_KEY, "true")
            window.dispatchEvent(new Event(SESSION_STORAGE_EVENT))
        }
    },

    clearSessionInvalid: () => {
        sessionStorage.removeItem(SESSION_INVALID_KEY)
        window.dispatchEvent(new Event(SESSION_STORAGE_EVENT))
    },

    setRedirectUrl: (url: string) => sessionStorage.setItem(REDIRECT_URL_KEY, url),
    getRedirectUrl: () => sessionStorage.getItem(REDIRECT_URL_KEY),
    clearRedirectUrl: () => sessionStorage.removeItem(REDIRECT_URL_KEY),

    clear: () => sessionStorage.clear(),
}
